import { Typography, Row, Col } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined, EnvironmentOutlined, TeamOutlined } from '@ant-design/icons';
import styles from './style.module.css';

const { Title, Text } = Typography;

interface Detail {
  labelKey?: string;
  valueKey: string;
}

interface BasicInfoItem {
  icon: React.ReactNode;
  titleKey: string;
  descKey: string;
  details?: Detail[];
  noteKey?: string;
}

const icons = {
  what: <InfoCircleOutlined className={styles.icon} />,
  where: <EnvironmentOutlined className={styles.icon} />,
  whom: <TeamOutlined className={styles.icon} />,
};

const BasicInfoBar: React.FC = () => {
  const { t } = useTranslation();

  const data: BasicInfoItem[] = [
    {
      icon: icons.what,
      titleKey: 'basicInfo.what.title',
      descKey: 'basicInfo.what.desc',
      details: [{ valueKey: 'basicInfo.what.price' }],
    },
    {
      icon: icons.where,
      titleKey: 'basicInfo.where.title',
      descKey: 'basicInfo.where.desc',
      details: [{ labelKey: 'basicInfo.where.locationsLabel', valueKey: 'basicInfo.where.locationsValue' }],
    },
    {
      icon: icons.whom,
      titleKey: 'basicInfo.whom.title',
      descKey: 'basicInfo.whom.desc',
      details: [
        { labelKey: 'basicInfo.whom.familyLabel', valueKey: 'basicInfo.whom.familyValue' },
        { labelKey: 'basicInfo.whom.teamLabel', valueKey: 'basicInfo.whom.teamValue' },
      ],
    },
  ];

  return (
    <div className={styles.barContainer}>
      <Row align="middle" justify="space-around" gutter={[8, 16]} style={{ height: '100%' }}>
        {data.map(({ icon, titleKey, descKey, details, noteKey }) => (
          <Col xs={24} sm={8} key={titleKey}>
            <div className={styles.item}>
              {icon}
              <Title level={3}>{t(titleKey)}</Title>
              <Text className={styles.desc}> {t(descKey)}</Text>
              {details &&
                details.map(({ labelKey, valueKey }, idx) => (
                  <Text key={idx} strong className={styles.detail} style={{ whiteSpace: 'pre-line' }}>
                    {labelKey ? (
                      <>
                        <span className={styles.detailLabel}>{t(labelKey)}</span> {t(valueKey)}
                      </>
                    ) : (
                      t(valueKey)
                    )}
                  </Text>
                ))}
              {noteKey && <Text className={styles.note}>{t(noteKey)}</Text>}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default BasicInfoBar;
